<template>
  <el-dialog
    :model-value="modelValue"
    :close-on-click-modal="false"
    :align-center="false"
    :z-index="3040"
    width="92%"
    top="5vh"
    class="catalog-insured-dialog-panel catalog-insured-card-dialog catalog-insured-dialog-panel--main"
    :class="{ 'catalog-insured-dialog-panel--nested': !isEditing }"
    :title="dialogTitle || $t('catalogDialogTitleInsuredCard')"
    modal-class="catalog-insured-overlay catalog-insured-overlay--dual"
    :destroy-on-close="true"
    append-to-body
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <el-form
      ref="formRef"
      class="insured-dialog-form catalog-person-form catalog-person-form--split catalog-person-form--errors-border-only"
      label-position="top"
      :rules="rules"
      :model="values"
      @submit.prevent
    >
      <div class="catalog-person-form__layout">
        <div class="catalog-person-form__col">
          <h3 class="catalog-person-form__title">{{ $t("identity_card") || "Şəxsiyyət vəsiqəsi" }}</h3>
          <div class="catalog-person-form__id-block">
            <div class="catalog-person-form__id-row">
              <el-form-item
                class="catalog-person-form__pin-item catalog-person-form__pin-item--data"
                :label="$t('pinCode') || 'PİN Kod'"
                prop="pin"
              >
                <el-input v-model="values.pin" maxlength="7" :disabled="isIdentityLocked" />
              </el-form-item>
              <el-form-item
                class="catalog-person-form__doc-item catalog-person-form__doc-item--data"
                :label="$t('catalogDocSeriesNumber')"
              >
                <div
                  class="catalog-person-form__doc-combo"
                  :class="{ 'catalog-person-form__doc-combo--disabled': isIdentityLocked }"
                >
                  <el-form-item prop="docSeries" label-width="0" class="catalog-person-form__doc-field">
                    <el-input
                      v-model="values.docSeries"
                      maxlength="3"
                      class="catalog-person-form__doc-series"
                      :placeholder="$t('series')"
                      :disabled="isIdentityLocked"
                    />
                  </el-form-item>
                  <span class="catalog-person-form__doc-divider" aria-hidden="true" />
                  <el-form-item prop="docNumber" label-width="0" class="catalog-person-form__doc-field">
                    <el-input
                      v-model="values.docNumber"
                      class="catalog-person-form__doc-number"
                      :placeholder="$t('number')"
                      :disabled="isIdentityLocked"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
            </div>
          </div>

          <h3 class="catalog-person-form__title">{{ $t("general_info") || "Ümumi məlumat" }}</h3>
          <div class="catalog-person-form__row catalog-person-form__row--3">
            <el-form-item :label="$t('lastName') || 'Soyadı'" prop="lastName">
              <el-input v-model="values.lastName" :disabled="isIdentityLocked" />
            </el-form-item>
            <el-form-item :label="$t('firstName') || 'Adı'" prop="firstName">
              <el-input v-model="values.firstName" :disabled="isIdentityLocked" />
            </el-form-item>
            <el-form-item :label="$t('middleName') || 'Atasının adı'" prop="middleName">
              <el-input v-model="values.middleName" :disabled="isIdentityLocked" />
            </el-form-item>
          </div>
          <div class="catalog-person-form__row catalog-person-form__row--2">
            <el-form-item :label="$t('sex') || 'Cinsi'">
              <el-select v-model="values.sex" :disabled="isIdentityLocked">
                <el-option :label="$t('male') || 'Kişi'" value="m" />
                <el-option :label="$t('female') || 'Qadın'" value="f" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('birthDateAge') || 'Doğum tarixi'" prop="dateOfBirth">
              <el-date-picker
                v-model="values.dateOfBirth"
                format="DD.MM.YYYY"
                type="date"
                :placeholder="$t('pickDate')"
                style="width: 100%"
                :disabled="isIdentityLocked"
                :disabled-date="(date) => date > new Date() || date < new Date('1900-01-01')"
              />
            </el-form-item>
          </div>
        </div>

        <div class="catalog-person-form__col catalog-person-form__col--right">
          <h3 class="catalog-person-form__title">{{ $t("contactLabel") || "Əlaqə" }}</h3>
          <div class="catalog-person-form__row catalog-person-form__row--2">
            <el-form-item :label="$t('mobilePhone') || 'Mobil telefon'" prop="mobilePhone">
              <CatalogMobilePhoneInput v-model="values.mobilePhone" />
            </el-form-item>
            <el-form-item :label="$t('emailLabel') || 'Email'" prop="email">
              <el-input v-model="values.email" />
            </el-form-item>
          </div>
          <h3 class="catalog-person-form__title catalog-person-form__title--gap">{{ $t("address") || "Ünvan" }}</h3>
          <el-form-item class="catalog-person-form__address-line" :label="$t('address') || 'Ünvan'" prop="address">
            <el-input
              v-model="values.address"
              :disabled="isAddressLocked"
            />
          </el-form-item>
          <el-form-item class="catalog-person-form__zip-item" :label="$t('postalCode') || 'Poçt indeksi'">
            <el-input v-model="values.zip" maxlength="10" :disabled="isAddressLocked" />
          </el-form-item>
        </div>
      </div>

      <div class="insured-dialog-footer">
        <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" @click="close">
          {{ $t("btnCancel") }}
        </button>
        <button type="button" class="insured-dialog-btn insured-dialog-btn--primary" @click="submit">
          {{ isEditing ? $t("catalogInsuredQueueSave") : $t("catalogInsuredCardDialogSave") }}
        </button>
      </div>
    </el-form>
  </el-dialog>

  <CatalogPersonSearchDialog
    v-if="modelValue && !isEditing"
    :model-value="modelValue"
    :z-index="3032"
    v-model:pin="searchDraft.pin"
    v-model:doc-series="searchDraft.docSeries"
    v-model:doc-number="searchDraft.docNumber"
    v-model:search-mode="searchDraft.searchMode"
    :loading="searchLoading"
    nested
    @update:model-value="close"
    @search="searchPersonByPin"
  />
</template>

<script>
import Utils from "@/project/Source/utils";
import MedicalAgent from "../Source/medicalAgent";
import { normalizePin } from "./catalogAgentRequest.js";
import { isQueuedPersonValid } from "./catalogInsuredQueue.js";
import { isAzerbaijanMobilePhone } from "./catalogPhone.js";
import CatalogMobilePhoneInput from "./CatalogMobilePhoneInput.vue";
import CatalogPersonSearchDialog from "./CatalogPersonSearchDialog.vue";
import {
  buildPersonInfoRequest,
  CATALOG_PERSON_SEARCH_MODE,
  emptyPersonSearchDraft,
  extractPersonInfoErrorMessage,
  extractPersonInfoRow,
  isPersonInfoFound,
  mapPersonInfoToForm,
  omitTestIdDocFromMapped,
  validatePersonInfoSearchInput,
} from "./catalogPersonSearch.js";

function emptyValues() {
  return {
    sex: "m",
    pin: "",
    docSeries: "",
    docNumber: "",
    lastName: "",
    firstName: "",
    middleName: "",
    dateOfBirth: null,
    mobilePhone: "",
    email: "",
    address: "",
    zip: "",
  };
}

function emptySearchDraft() {
  return emptyPersonSearchDraft();
}

export default {
  name: "CatalogInsuredCardDialog",
  components: { CatalogMobilePhoneInput, CatalogPersonSearchDialog },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    /** Entry being edited: { values, searchedPin, isAsan }. Null — add mode. */
    draft: {
      type: Object,
      default: null,
    },
    dialogTitle: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "confirm"],
  data() {
    return {
      values: emptyValues(),
      searchDraft: emptySearchDraft(),
      searchedPin: null,
      personSearchDone: false,
      searchLoading: false,
    };
  },
  computed: {
    rules() {
      const required = {
        required: true,
        message: " ",
        trigger: "change",
      };
      // Manual mode: PIN / series / number optional.
      const identityRules = this.isManualEntry ? {} : {
        pin: [required],
        docSeries: [required],
        docNumber: [required],
      };
      return {
        ...identityRules,
        address: [required],
        lastName: [required],
        firstName: [required],
        middleName: [required],
        dateOfBirth: [required],
        mobilePhone: [
          {
            validator: (_rule, value, callback) => {
              const trimmed = value != null ? String(value).trim() : "";
              if (!trimmed || !isAzerbaijanMobilePhone(trimmed)) {
                callback(new Error(" "));
                return;
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        email: [
          required,
          {
            type: "email",
            message: " ",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    isEditing() {
      return this.draft != null;
    },
    isManualMode() {
      return this.searchDraft.searchMode === CATALOG_PERSON_SEARCH_MODE.MANUAL;
    },
    /** Manual entry (add mode: manual search mode; edit mode: entry not from ASAN). */
    isManualEntry() {
      if (this.isEditing) return this.draft?.isAsan !== true;
      return this.isManualMode;
    },
    isIdentityLocked() {
      if (this.isEditing) return this.draft?.isAsan === true;
      return !this.isManualMode;
    },
    isAddressLocked() {
      if (this.isEditing) return false;
      return !this.isManualMode;
    },
  },
  watch: {
    modelValue(open) {
      if (!open) return;
      if (this.draft) {
        this.loadDraft(this.draft);
      } else {
        this.resetForm();
      }
    },
    "searchDraft.searchMode"() {
      if (this.isEditing) return;
      this.personSearchDone = false;
      this.searchedPin = null;
    },
    "values.pin"(next) {
      if (this.isEditing || this.isManualMode) return;
      if (!this.personSearchDone) return;
      if (normalizePin(next) !== normalizePin(this.searchedPin)) {
        this.personSearchDone = false;
        this.searchedPin = null;
      }
    },
  },
  methods: {
    resetForm() {
      this.values = emptyValues();
      this.searchDraft = emptySearchDraft();
      this.searchedPin = null;
      this.personSearchDone = false;
      this.searchLoading = false;
      this.$nextTick(() => this.$refs.formRef?.clearValidate?.());
    },
    loadDraft(draft) {
      this.values = { ...emptyValues(), ...(draft.values || {}) };
      this.searchDraft = emptySearchDraft();
      this.searchDraft.searchMode = draft.isAsan
        ? CATALOG_PERSON_SEARCH_MODE.ASAN
        : CATALOG_PERSON_SEARCH_MODE.MANUAL;
      this.searchedPin = normalizePin(draft.searchedPin || draft.values?.pin);
      this.personSearchDone = draft.isAsan === true;
      this.searchLoading = false;
      this.$nextTick(() => this.$refs.formRef?.clearValidate?.());
    },
    close() {
      this.$emit("update:modelValue", false);
    },
    searchPersonByPin() {
      if (this.isManualMode || this.isEditing) return;

      const check = validatePersonInfoSearchInput(
        this.searchDraft.pin,
        this.searchDraft.docSeries,
        this.searchDraft.docNumber
      );
      if (!check.ok) {
        Utils.Alert(this.$t("catalogPinRequired"));
        return;
      }

      const pinForSearch = normalizePin(check.pin);
      this.searchLoading = true;
      this.personSearchDone = false;
      this.searchedPin = null;

      const payload = buildPersonInfoRequest(pinForSearch, {
        idSeries: check.idSeries,
        idNumber: check.idNumber,
      });
      const usedTestIdDoc = Boolean(payload._usedTestIdDoc);
      delete payload._usedTestIdDoc;

      MedicalAgent.GetPersonInfo(payload)
        .then((response) => {
          const row = extractPersonInfoRow(response);
          if (!isPersonInfoFound(row)) {
            const apiErr =
              extractPersonInfoErrorMessage(response) ||
              Utils.formatApiErrors(response?.data?.errors);
            Utils.Alert(apiErr || this.$t("catalogPersonNotFound"));
            return;
          }

          const mapped = omitTestIdDocFromMapped(mapPersonInfoToForm(row), usedTestIdDoc);
          this.values = {
            ...this.values,
            pin: pinForSearch,
            docSeries: mapped.docSeries ?? this.searchDraft.docSeries ?? "",
            docNumber: mapped.docNumber ?? this.searchDraft.docNumber ?? "",
            ...mapped,
          };
          this.searchedPin = pinForSearch;
          this.personSearchDone = true;
        })
        .catch((error) => {
          console.error("[Catalog] GetPersonInfo (card):", error?.response?.data ?? error);
          const msg = Utils.FormatErrorWithCorrelationId(error);
          if (msg) Utils.Alert(msg);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const isAsan = this.isEditing
          ? this.draft?.isAsan === true
          : !this.isManualMode && this.personSearchDone;

        const pin = normalizePin(
          isAsan ? this.searchedPin || this.values.pin : this.values.pin || this.searchedPin
        );

        if (!this.isEditing && !this.isManualMode) {
          if (!pin) {
            Utils.Alert(this.$t("catalogPinRequired"));
            return;
          }
          if (!this.personSearchDone) {
            Utils.Alert(this.$t("catalogPinSearchRequired"));
            return;
          }
        }

        const payload = { ...this.values, pin };
        if (!isQueuedPersonValid(payload)) {
          Utils.Alert(this.$t("catalogInsuredQueueInvalid"));
          return;
        }

        // Parent decides whether to accept (pin conflicts) and closes the dialog itself.
        this.$emit("confirm", payload, pin, isAsan);
      });
    },
  },
};
</script>
